import { connect } from 'react-redux';
import EligibilityProcessingOverlay from './EligibilityProcessingOverlay';

const mapStateToProps = state => ({
  isVisible: state.eligibility.isAcceptingEligibility || state.eligibility.isAgentProcessing,
  isAgentProcessing: state.eligibility.isAgentProcessing,
});

export default connect(mapStateToProps)(EligibilityProcessingOverlay);
